"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HORIZONTAL = exports.VERTICAL = void 0;
var VERTICAL = 'vertical';
exports.VERTICAL = VERTICAL;
var HORIZONTAL = 'horizontal';
exports.HORIZONTAL = HORIZONTAL;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-scroll-parallax/cjs/constants.js
// module id = 30
// module chunks = 0